// Angular
import { Injectable } from '@angular/core';

// Afidium
import { Yii } from 'libraries/interfaces/Yii';
import { IAccommodation } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { IServicesTableGroups, IServicesTableColumns } from '../../components/services-table/IServicesTableConfig';
import { ServiceCategory } from 'libraries/service/resources/booking/interfaces/get-bookings.enum';

@Injectable()
export class SectorStayServicesService {
    public getAccommodationsGroup(accommodation: IAccommodation[]): IServicesTableGroups {
        const columns: IServicesTableColumns[] = accommodation.filter((room: IAccommodation, index: number, accommodationArray: IAccommodation[]) =>
            index === accommodationArray.findIndex((acco: IAccommodation) => (acco.code === room.code))
        ).map((room: IAccommodation) => ({
            columnDef: room.code,
            header: room.name
        }));

        return {
            name: Yii.t('wui-shared-js', 'Types'),
            columns
        };
    }

    public getServiceCategoryLabel(serviceCategory: ServiceCategory): string {
        switch (serviceCategory) {
            case ServiceCategory.mealplan: return Yii.t('wui-shared-js', "Repas");
            case ServiceCategory.accommodation: return Yii.t('wui-shared-js', "Type de chambre");
            default: return null;
        }
    }

}
